<template>
    <span v-if="mostrarBtn">
        <b-button variant="warning" @click.stop="confirmarRetornarFinalizacao()">
            <span> <i class="fa fa-undo"></i> Retornar Finalização </span>
        </b-button>
    </span>

</template>

<script>
import { finalizacoesStatus } from './FinalizacoesStatus';

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmarRetornarFinalizacao() {
            this.$swal({
                title: `Registro de Pagamento`,
                html: `Confirma o retorno do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.retornarFinalizacao()
                }
            })
        },

        retornarFinalizacao() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos.retornarFinalizacao(this.finalizacao.finalizacaoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Finalização retornado para a UABS',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterFinalizacaoAtualizada')
                    }
                    else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtn() {
            return this.$route.name == 'Uabs_Finalizacoes_Detalhar'
                && this.$temAcessoView('CRED-UABS-FIN-02')
                && this.finalizacao.status == finalizacoesStatus.AGUARDANDO_SETOR_FINANCEIRO
        }
    }
}
</script>